import { makeStyles } from 'tss-react/mui';

export default makeStyles<void, 'container' | 'indicator'>({ name: 'NavBarItem' })((_, __, classes) => ({
    container: {
        position: 'relative',
        display: 'flex',
        minWidth: 88,
        maxWidth: 88,
        boxSizing: 'border-box',
        flexDirection: 'column',
        alignItems: 'center',
        padding: 12,
        borderRadius: 16,
        border: '1px solid #ECECEC',
        transition: 'all 0.2s',
        cursor: 'pointer',
        background: '#FFF',
        color: '#2D2D2D',
        opacity: 0.7,
        '&:hover': {
            opacity: 1,
            background: '#F8F8F8'
        }
    },
    icon: {
        marginTop: 8,
        marginBottom: 12
    },
    title: {
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '18px'
    },
    indicator: {
        position: 'absolute',
        bottom: 0,
        width: 40,
        height: 4,
        borderRadius: '20px 20px 0px 0px',
        background: '#2D2D2D',
        transition: 'all 0.2s',
        opacity: 0
    },
    _active: {
        [`&.${classes.container}`]: {
            borderColor: '#F8F8F8',
            background: '#F8F8F8',
            opacity: 1
        },
        [`&.${classes.indicator}`]: {
            opacity: 1
        }
    }
}));
